import { JDI_TOKEN } from '@jdiyield/constants'

export type VoteDetail = {
  candidates: Candidate[]
  totalBalance: string
}

export type VoteTopic = {
  id: string
  startTime: number
  endTime: number
  tokenContract: string
  min: string
  max: string
  balance: string
}

export type Candidate = {
  id: number
  voteCount: string
}

export type UserVote = {
  walletAddress: string
  candidate: Candidate
}

export type Vote = {
  id: number
  title: string
  desc: string
  startTime: number
  endTime: number
  candidates: CandidateDetail[]
  category: Category
  tokenContract: string
  tokenName: string
  decimal: number
  status: string
}

export type Category = {
  id: number
  type: string
}

export type CandidateDetail = {
  id: number
  title: string
  name: string
  desc: string[]
}

const proFeatureData: Vote = {
  id: 0,
  title: 'PRO Features Options',
  desc: 'Initially as stated in our white paper, users are required to have 2000 JDI in order to use PRO features. However, due to price fluctuations, 2,000 JDI is no longer affordable and applicable to many users. We want to have more options for users to use, so as to expand user base.',
  startTime: 1624244400,
  endTime: 1624590000,
  category: {
    id: 0,
    type: 'feature'
  },
  tokenContract: JDI_TOKEN,
  tokenName: 'JDI',
  decimal: 1e18,
  status: 'IN PROGRESS',
  candidates: [
    {
      id: 0,
      title: 'No Changes',
      name: 'A',
      desc: ['Remain as planned at 2,000 JDI. No subscription.']
    },
    {
      id: 1,
      title: 'Add subscription and burn the JDI fees.',
      name: 'B',
      desc: [
        'Hold 2,000 JDI for a PRO usage, or',
        'Pay 50 JDI for a month usage',
        'Pay 500 JDI for a year usage',
        'The JDI subscription amount can be changed as per community vote.',
        'Burn all the JDI fees'
      ]
    },
    {
      id: 2,
      title: 'Add subscription and burn 50% the fees.',
      name: 'C',
      desc: [
        'Hold 2,000 JDI for a PRO usage, or',
        'Pay 50 JDI for a month usage',
        'Pay 500 JDI for a year usage',
        'The JDI subscription amount can be changed as per community vote.',
        'Burn 50% the fees',
        '50% get distributed to JDI locked staking pool (Tiers)'
      ]
    }
  ]
}

const adsOnJdi: Vote = {
  id: 1,
  title: 'Ads on JDIYIELD',
  desc: "We plan on making JDI Yield  live on its own feet, other than the subscription model for PRO features. With 40k-100k monthly visitors,  and with users  sticking to our platform for  yield farming, we plan to introduce ads on the platform. As a JDI holder, wouldn't it interest you to see ads on our platform? Surely, users can upvote or downvote in case they find the ads irrelevant. We will introduce some mechanisms to allow users to participate. You guys can vote between these 2 options:",
  startTime: 1630587600,
  endTime: 1631192400,
  category: {
    id: 0,
    type: 'feature'
  },
  tokenContract: JDI_TOKEN,
  tokenName: 'JDI',
  decimal: 1e18,
  status: 'IN PROGRESS',
  candidates: [
    {
      id: 0,
      title: 'Show ads.',
      name: 'A',
      desc: [
        'Show non-intrusive ads on the platform. Parts of the revenue will be used to pay the locked staking JDI holders and others for the team.'
      ]
    },
    {
      id: 1,
      title: 'No ads.',
      name: 'B',
      desc: ['No ads please. We want to see JDI Yield clean.']
    }
  ]
}

export const dataVoteList: Vote[] = [proFeatureData, adsOnJdi]
